import { Dispatch as ReduxDispatch } from 'redux';

import ItemReducerType from '../../common/store/ItemReducerType';
import { PayloadAction } from '../../common/store/redux';
import { ACTION, GenericItemReducerAction } from '../../common/store/ReduxHelper';

export interface GroceryListShareDto {
  id:    number;
  list:  number; // id
  shared_by:            number;
  shared_by_username:   string;
  shared_to:            number;
  shared_to_username:   string;
}

export type GroceryListShare = GroceryListShareDto;

export const toGroceryListShare = (dto: GroceryListShareDto): GroceryListShare => dto;

export interface GroceryListShareCreateDto {
  list: number;
  shared_to_name: string;
}

export interface GroceryListShareCreate {
  shared_to_name: string;
}

export const GROCERY_LIST_SHARE_STORE = 'groceryListShare';

export type IGroceryListShareDeleteSuccessAction = {
  typs: typeof ACTION.DELETE_SUCCESS;
} & PayloadAction<{ listId: number, id: number }>;

export type GroceryListShareState     = ItemReducerType<GroceryListShare>;
export type GroceryListShareAction    = IGroceryListShareDeleteSuccessAction | GenericItemReducerAction<GroceryListShare>;
export type GroceryListShareDispatch  = ReduxDispatch<GroceryListShareAction>;
